import { render, staticRenderFns } from "./Boundary.vue?vue&type=template&id=34816afa&scoped=true"
import script from "./Boundary.vue?vue&type=script&lang=js"
export * from "./Boundary.vue?vue&type=script&lang=js"
import style0 from "./Boundary.vue?vue&type=style&index=0&id=34816afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34816afa",
  null
  
)

export default component.exports